(function($) {
    let padTime                 = 25;
    let padTimeSeconds          = padTime / 1000;
    let transitionTime          = 750;
    let transitionTimeSeconds   = transitionTime / 1000;
    let activeClass             = 'active';
    let currentClass            = 'current';
    let containerClass          = '.container';

    let isTransitioning         = false;

    function advanceSlider() {
        console.log('Advance');
        let videos          = $('.video-fade video');
        let count           = 0;
        let isLast          = false;
        let openVideo       = false;
        let currentFound    = false;
        $('.video-fade video').each(function() {
            if( currentFound ) return;
            let $video  = $(this);
            let $container  = $video.closest(containerClass);
            if( openVideo ) {
                $video.get(0).play();
                $container.addClass(activeClass);
                openVideo       = false;
                currentFound    = true;
                return;
            }
            if( $container.hasClass(currentClass) ) {
                $container.removeClass(activeClass);
                $container.removeClass(currentClass);
                if( count === videos.length - 1 ) {
                    isLast = true;
                } else {
                    openVideo = true;
                }
            }
            count++;
        });
        if( isLast ) {
            $(videos[0]).get(0).play();
            $(videos[0]).closest(containerClass).addClass(activeClass);
        }
    }

    $(document).ready(function() {
        $('.video-fade video').each(function() {
            let $container = $(this).closest(containerClass);
            $(this).on('timeupdate', function() {
                let $video = $(this);
                if( isTransitioning || !$container.hasClass(activeClass) ) return;
                $container.addClass(currentClass);
                let currentTime = $video.get(0).currentTime;
                let duration    = this.duration;
                let cutoff      = duration - transitionTimeSeconds - 1;

                console.log(`Duration: ${duration} Cutoff: ${cutoff} Current Time: ${currentTime}`);

                if( currentTime > cutoff ) {
                    isTransitioning = true;
                    $container.removeClass(activeClass);
                    setTimeout(function() {
                        advanceSlider();
                        $video.get(0).currentTime = 0;
                        $video.get(0).pause();
                        isTransitioning = false;
                    }, transitionTime);
                }
            });
        });

        $('.start').on('click', function(event) {
            event.preventDefault();
            $('video.is-open').get(0).play();
        });
    });
    
})(jQuery)